<template>
  <b-list-group-item>
    <div class="text-muted font-small-2">
      <div v-if="dataModal.dataItem.created">
        {{ moment(dataModal.dataItem.created).format('llll') }} tarihinde {{ dataModal.dataItem.username }} tarafından oluşturuldu.
      </div>
      <div v-if="dataModal.dataItem.modified">
        {{ moment(dataModal.dataItem.modified).format('llll') }} tarihinde {{ dataModal.dataItem.username }} tarafından güncellendi.
      </div>
    </div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'NotesText',
  components: {
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
  },
}
</script>
